import { TRANSLATED_ACTIONS } from '@/common/messages/actions';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Page = defineMessages({
  helmet: {
    id: 'app.auth.oneTimePassword.Page.helmet',
  },
  title: {
    id: 'app.auth.oneTimePassword.Page.title',
  },
  description: {
    id: 'app.auth.oneTimePassword.Page.description',
  },
  sendAgain: {
    id: 'app.auth.oneTimePassword.Page.sendAgain',
  },
  verificationFailed: {
    id: 'app.auth.oneTimePassword.Page.verificationFailed',
  },
  emailNotReceived: {
    id: 'app.auth.oneTimePassword.Page.emailNotReceived',
  },
  otpVerification: {
    id: 'app.auth.oneTimePassword.Page.otpVerification',
  },
  cancel: TRANSLATED_ACTIONS.cancel,
  next: TRANSLATED_ACTIONS.next,
});
